import React, { useContext, useState } from 'react'
import { Link, Redirect, useHistory } from "react-router-dom";
import AuthContext from '../../context/Auth/AuthContext';
import { useTranslation } from 'react-i18next';
/*Input fields validations*/
import { validate_fields } from './validations.js';
/**Notifications */
import Notifications, { ERROR_NOTIFICATION, INFO_NOTIFICATION } from '../../helpers/notifications';
//Imports the axios instance to make API calls
import API from '../../services/api';

import './forgotPassword.css';

const ForgotPassword = () => {
    /*Translations*/
    const { t } = useTranslation('common');

    const history = useHistory();

    /**Context for validations*/
    const { is_login } = useContext(AuthContext);

    /*State of the Email input*/
    const [email, setEmail] = useState('');

    /**When user clicks the Get New password button this function is triggered*/
    const get_new_password = async () => {
        /* Validates if the email typed by user is correct */
        const error = validate_fields(email, t);
        if (error.length === 0) {
            /**Request parameters */
            const params = {
                usr: email
            }
            setEmail('');
            /**Call the API to send the temporary password*/
            const response = await API.post(`/security/rstpw`, params);
            /**Response data*/
            const { data } = response;
            /**Validations according to response code */
            if (data.code !== 100) {
                /**Shows error message */
                Notifications.notify(`Error ${data.code}`, ERROR_NOTIFICATION)
            } else {
                /**The password was successfully sent, so, the app redirects to Login Page */
                Notifications.notify('Temporary password successfully sent', INFO_NOTIFICATION)
                history.push('/Login');
            }
        } else {
            /**Shows error message */
            Notifications.notify(error, ERROR_NOTIFICATION)
        }
    }

    return !is_login() ? (
        <div className="container-fluid mt-3">
            <div className="row">
                <label className="col-sm-12 fp_label_title">{t('forgotPassword.title')}</label>
            </div>
            <div className="row justify-content-center">
                
                <div className="col-md-8">
                    
                    <div className="row ilo_login_input_container">
                        <div className="col-xs-7 col-sm-7 col-md-2 col-lg-2 col-xl-2 login-label-container">
                            <label className=" ilo_lbl_general labelLogin">{t('login.email')}</label>
                        </div>
                        <div className="col-xs-7 col-sm-7 col-md-5 col-lg-4 col-xl-3 ilo_login_input">
                            <input
                                type="email"
                                className="form-control ilo-input"
                                placeholder={t('login.email')}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        get_new_password()
                                    }
                                }}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                }}
                                value={email}
                            />
                        </div>
                    </div>
                    
                    <div className="row ilo_login_input_container change-pw-buttons-container">
                        <div className="col-xs-7 col-sm-7 col-md-7 col-lg-6 col-xl-5 ilo_login_input psw_login_btn">
                            <button onClick={get_new_password} type="submit" className="btn btn-primary ilo-btn fb-btn">{t('forgotPassword.gnp_button')}</button>
                            <Link to="/Login" type="submit" className="btn btn-primary ilo-btn fb-btn fb-btn-right">{t('forgotPassword.cancel_button')}</Link>
                        </div>
                    </div>

                </div>
                
            </div>
        </div>
    ) : (
        <Redirect
            to={{
                pathname: "/Home",
            }}
        />)
}

export default ForgotPassword;
